import React, { useState } from "react";
import { useHistory, useNavigate } from "react-router-dom";
import "./Login.css";
// import API from "../../utils/API";
import axios from "axios";
import AlertContext from "../../utils/alertContext";
// import jwt from "jsonwebtoken";
import UserNav from "../../Components/UserNav.jsx/UserNav";
import $ from "jquery";

const UserLog = (props) => {
  const [phone, setPhone] = useState("");
  const [name, setName] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate()

  // const alert = useContext(AlertContext);

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if(phone === "" || name === "") {
      setError("Please respond to both inputs!")
    } else {
        navigate('/services', { state: { name: name, phone: phone} })
    }
    // axios
    //   .post("/api/auth/login", { phone, name })
    //   .then((response) => {
    //     console.log(response.data);
        // jwt.verify(
        //   response.data.token,
        //   process.env.REACT_APP_JWT_SIGNATURE,
        //   (err, decoded) => {
        //     if (err) {
        //       console.log(err);
        //     } else {
        //       login(response.data.token, () => {
        //         props.history.push("/admin/orders");
        //       });
        //     }
        //   }
        // );
      // })
      // .catch((err) => {
      //   console.log(err);
      //   alert.setAlert({
      //     message: "Incorrect Username or Password please try again!",
      //     type: "danger",
      //   });
      // });
  };

  const onPhoneChange = (event) => {
    $(".number").keyup(function () {
      if (this.value.length === this.maxLength) {
        $(this).next(".number").focus();
      }
    });
    const val1 = $("#number1").val();
    const val2 = $("#number2").val();
    const val3 = $("#number3").val();
    setPhone(
      val1 + "-" + val2 + "-" + val3,
    );
  };

  return (
    <>
      <UserNav />
      <div className="container login-card">
        <div className="row">
          <div className="col s12 m6">
            <div className="card adminMenu">
              <div className="card-content white-text">
              <h3 className="center-align formHead">Guest Check-In</h3>
                <div className="row">
                  <form className="col s12 subform" onSubmit={handleFormSubmit}>
                    <div className="row">
                     <div className="input-field col s12">
                       <div className="row"></div>
                        <input
                          id="name"
                          type="text"
                          className="validate sign-input"
                          value={name}
                          onChange={(e) => {
                            setName(e.target.value);
                          }}
                        />
                        <label htmlFor="password">Name</label>
                      </div>
                    </div>
                    <div className="row">
                      <div className="input-field col s12">
                <div className="row"></div>
                <input
                  type="number"
                  id="number1"
                  className="number sign-input validate col s2"
                  maxlength="3"
                  size="3"
                  onChange={(e)=>onPhoneChange(e)}
                />{" "}
                -
                {" "}
                <input
                  type="number"
                  id="number2"
                  className="number sign-input validate col s2"
                  maxlength="3"
                  size="3"
                  onChange={(e)=>onPhoneChange(e)}
                />{" "}
                -
                {" "}
                <input
                  type="number"
                  id="number3"
                  className="number sign-input validate col s4"
                  maxlength="4"
                  size="5"
                  onChange={(e)=>onPhoneChange(e)}
                />
                 <label htmlFor="phone">Phone #</label>
              </div>
                      <p className="center-align red-text">{error}</p>
                      <button
                        className="btn waves-effect waves-light submit-button"
                        type="submit"
                        name="action"
                      >
                        Select Service
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserLog;
